export default __webpack_public_path__ + "static/kdc-seal-308e516196259d785c15e21a650b5640.png";